(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('DamageFormController', DamageFormController);


    DamageFormController.$inject = [
        '$stateParams',
        'averiaService',
        'genericDataService',
        '$filter',
        '$state',
        '$rootScope',
        'common',
        'notificationService',
        '$scope'
    ];

    function DamageFormController($stateParams, averiaService, genericDataService,
        $filter, $state, $rootScope, common, notificationService, $scope) {
        /* PRIVATE VARIABLES */
        var id = $stateParams.id;

        /* PUBLIC VARIABLES */
        var vm = this;
        vm.stateParams = $stateParams;
        vm.tipoIncidenciaOriginal = []; 
        vm.averia = {};
        vm.edit = false;
        vm.genericData = {
            tiposIncidencias: {
                list: null,
                selected: { id: null }
            },
            aseguradoras: {
                list: null,
                selected: { id: null }
            },
        };

        vm.onAseguradoraChange = onAseguradoraChange;
        vm.save = save;
        vm.saveAndClose = saveAndClose;
        vm.saveAndNew = saveAndNew;
        vm.effectClass = effectClass;
        vm.resizable = resizable;
        vm.firstOnChange = true; 

        vm.showEditIcon = showEditIcon;
        vm.hideEditIcon = hideEditIcon;
        vm.showEditIconValue = false;

        vm.accionSaveList = [
            {
                accionTexto: 'Guardar y cerrar',
                accion: vm.saveAndClose,
                selected: computeValueAccionSelected('saveAndClose')
            },
            {
                accionTexto: 'Guardar y nuevo',
                accion: vm.saveAndNew,
                selected: computeValueAccionSelected('saveAndNew')
            },
            {
                accionTexto: 'Guardar',
                accion: vm.save,
                selected: computeValueAccionSelected('save')
            },
        ];

        /* INITIALIZER */
        (function () {
            //Edit
            if (id != null) {
                vm.edit = true;
                averiaService.getById(id)
                    .then(function (averia) {
                        vm.averia = averia;
                        getGenericData();
                    });
            }
            else {
                getGenericData(); 
            }
        })();



        function getGenericData() {
            genericDataService.getAseguradoras()
                .then(function (res) {
                   
                    vm.genericData.aseguradoras.list = res;
                    var found = false;
                    if (!common.isNullOrUndefined(vm.averia.aseguradoraId)) {
                        var model = findByProperty(vm.genericData.aseguradoras.list, 'id', vm.averia.aseguradoraId);
                        if (model) {
                            vm.genericData.aseguradoras.selected = model; 
                            found = true; 
                        }
                    }
                    if (!found) vm.genericData.aseguradoras.selected = vm.genericData.aseguradoras.list[0];
                    genericDataService.getTiposIncidencias()
                        .then(function (res) {
                            vm.tipoIncidenciaOriginal = res;
                            vm.genericData.tiposIncidencias.list = vm.tipoIncidenciaOriginal.filter(incidencia => incidencia.aseguradoraId == vm.genericData.aseguradoras.selected.id);
                            var found2 = false;
                            if (!common.isNullOrUndefined(vm.averia.tipoIncidenciaId)) {
                                var tipo = findByProperty(vm.genericData.tiposIncidencias.list, 'tipoIncidenciaId', vm.averia.tipoIncidenciaId);
                                if (tipo) {
                                    vm.genericData.tiposIncidencias.selected = tipo;
                                    found2 = true; 
                                }
                            }
                            if (!found2) {
                                vm.genericData.tiposIncidencias.selected = vm.genericData.tiposIncidencias.list[0];
                            }

                        });

                });
          
        }
        function computeValueAccionSelected(accion) {
            if (accion === vm.stateParams.accion) { return true; }
            return false;
        }


        /* PRIVATE FUNCTIONS */


        function doSave(action) {
            if (vm.edit && (vm.averia.id === null || vm.averia.id === '' || vm.averia.id === undefined)) {
                sendErrorRequire();
                return;
            }
            vm.averia.aseguradoraId = vm.genericData.aseguradoras.selected.id;
            vm.averia.tipoIncidenciaId = vm.genericData.tiposIncidencias.selected.tipoIncidenciaId; 

            averiaService.add(vm.averia).then(function (averiaSave) {
                sendSAveNotification();
                vm.edit = true;
                if (action === 'saveAndClose') {
                    $state.go('flota.configuracion.listadoAverias');
                }
                else if (action === 'saveAndNew') {
                    $state.go('flota.configuracion.nuevaAveria', { 'accion': 'saveAndNew' });
                }
                else {
                    vm.averia.id = averiaSave.id;
                    vm.averia.averiaId = averiaSave.averiaId;
                }
            });
        }

        function sendSAveNotification() {
            notificationService.sendAppNotification({
                message: 'La aver�a se ha guardado correctamente',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
            });
        }

        function save() {
            var action = 'save';
            for (var i = 0; i < vm.accionSaveList.length; ++i) {
                if (vm.accionSaveList[i].accionTexto === 'Guardar') { vm.accionSaveList[i].selected = true; }
                else { vm.accionSaveList[i].selected = false; }
            }
            doSave(action);
        }

        function saveAndClose() {
            var action = 'saveAndClose';
            doSave(action);
        }

        function saveAndNew() {
            for (var i = 0; i < vm.accionSaveList.length; ++i) {
                if (vm.accionSaveList[i].accionTexto === 'Guardar y nuevo') { vm.accionSaveList[i].selected = true; }
                else { vm.accionSaveList[i].selected = false; }
            }
            var action = 'saveAndNew';
            doSave(action);
        }

        function sendSAveNotification() {
            notificationService.sendAppNotification({
                message: 'La averia se ha guardado correctamente',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
            });
        }

        function sendErrorRequire() {
            notificationService.sendAppNotification({
                message: 'El campo Id es obligatorio',
                positionY: 'top', positionX: 'right', delay: 3000, type: 'error'
            });
        }


        function effectClass(target) {
            vm.effects = {};
            vm.effects[target] = true;
            setTimeout(function () {
                vm.effects[target] = undefined;
            }, 3000);
        }

        function resizableInput(el, factor) {
            var int = Number(factor) || 7.7;
            function resize() { el.style.width = ((el.value.length + 1) * int) + 'px'; }
            var e = 'keyup,keypress,focus,blur,change'.split(',');
            for (var i in e) { el.addEventListener(e[i], resize, false); }
            resize();
        }

        function resizable() {
            resizableInput(document.getElementById('txt'), 7);
        }

        function showEditIcon(e) {
            vm.showEditIconValue = true;
        }

        function hideEditIcon(e) {
            if (!$(e.currentTarget).is(":focus"))
                vm.showEditIconValue = false;
        }

        function onAseguradoraChange() {
            //console.log(vm.genericData.aseguradoras.selected.id);
            //console.log(vm.tipoIncidenciaOriginal);
            if (!vm.firstOnChange) {
                vm.genericData.tiposIncidencias.list = vm.tipoIncidenciaOriginal.filter(incidencia => incidencia.aseguradoraId == vm.genericData.aseguradoras.selected.id);
                //console.log(vm.genericData.tiposIncidencias.list);
                vm.genericData.tiposIncidencias.selected = vm.genericData.tiposIncidencias.list[0];
            //console.log(vm.genericData.tiposIncidencias.selected);
            }
            if (vm.firstOnChange) vm.firstOnChange = false; 
           
            //$rootScope.$apply();
        }

        function findByProperty(array, property, id) {
            if (array === null) { return null; }
            for (var i = 0; i < array.length; i++) {
                if (array[i][property] === id) {
                    return array[i];
                }
            }
            return null;
        }

       

           
            
    }


})();

